module.exports = __webpack_public_path__ + "img/wbs2.826ec3e2.png";